var I18N_ERROR_AVAILABILITY, I18N_ERROR_BAD_LOCATION, I18N_ERROR_BAD_LOCATION_ENTRY, I18N_ERROR_GENERIC, LocationError, getTranslations, moveAutocomplete, ref,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

I18N_ERROR_GENERIC = 'generic';

I18N_ERROR_BAD_LOCATION = 'bad_location';

I18N_ERROR_BAD_LOCATION_ENTRY = 'bad_location_entry';

I18N_ERROR_AVAILABILITY = 'availability';

ref = require('../helper/m_typeahead_helper'), getTranslations = ref.getTranslations, moveAutocomplete = ref.moveAutocomplete;

module.exports = LocationError = (function() {
  function LocationError(opts) {
    this.removeError = bind(this.removeError, this);
    this.displayError = bind(this.displayError, this);
    this.$el = opts.$el, this.env = opts.env, this.$resultList = opts.$resultList, this.expUX = opts.enableBetterUx;
    this.hasError = false;
    this.classes = this.expUX ? 'ls-error' : 'ls-error ls-error-old ';
    this.$locationWrapper = this.$el.find('.location-search, .ls-location-wrap');
  }

  LocationError.prototype.errorTemplate = function(query, message) {
    query = _.escape(query);
    message = _.escape(message);
    return "<ul role='list'><li data-bhw='SearchBarError' class='ls-error-dialog icon-circle-alert'>\n  <span data-bhc='location-not-found:" + query + "'>" + message + "</span>\n</li></ul>";
  };

  LocationError.prototype.displayError = function(message, query) {
    var $errorDialog, event;
    message || (message = this.translateError(I18N_ERROR_GENERIC));
    $errorDialog = $(this.errorTemplate(query, message));
    moveAutocomplete(this.$resultList, 'location', this.env);
    this.$locationWrapper.addClass(this.classes);
    this.$resultList.html($errorDialog).show();
    this.$locationWrapper.find('input').one('input.locationError', this.removeError);
    this.hasError = true;
    switch (this.env) {
      case 'desktop':
        event = 'mousedown';
        break;
      case 'mobile':
        event = 'touchend';
    }
    return $(window).one(event, this.removeError);
  };

  LocationError.prototype.removeError = function() {
    if (this.hasError) {
      this.$resultList.hide().find('.ls-error-dialog').remove();
      this.$locationWrapper.removeClass(this.classes);
      this.hasError = false;
    }
  };

  LocationError.prototype.displayBadLocationError = function(query) {
    var message, txtKey;
    if (this.expUX) {
      txtKey = I18N_ERROR_BAD_LOCATION_ENTRY;
    } else {
      txtKey = I18N_ERROR_BAD_LOCATION;
    }
    message = this.translateError(txtKey);
    return this.displayError(message, query);
  };

  LocationError.prototype.displayAvailabilityError = function(query) {
    var message;
    message = this.translateError(I18N_ERROR_AVAILABILITY);
    return this.displayError(message, query);
  };

  LocationError.prototype.translateError = function(key) {
    return getTranslations('error')[key];
  };

  return LocationError;

})();

//# sourceMappingURL=data:application/json;base64,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
